var I18N_ERROR_AVAILABILITY, I18N_ERROR_BAD_LOCATION, I18N_ERROR_BAD_LOCATION_ENTRY, I18N_ERROR_GENERIC, LocationError, getTranslations, moveAutocomplete, ref,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

I18N_ERROR_GENERIC = 'generic';

I18N_ERROR_BAD_LOCATION = 'bad_location';

I18N_ERROR_BAD_LOCATION_ENTRY = 'bad_location_entry';

I18N_ERROR_AVAILABILITY = 'availability';

ref = require('../helper/m_typeahead_helper'), getTranslations = ref.getTranslations, moveAutocomplete = ref.moveAutocomplete;

module.exports = LocationError = (function() {
  function LocationError(opts) {
    this.removeError = bind(this.removeError, this);
    this.displayError = bind(this.displayError, this);
    this.$el = opts.$el, this.env = opts.env, this.$resultList = opts.$resultList, this.expUX = opts.enableBetterUx;
    this.hasError = false;
    this.classes = this.expUX ? 'ls-error' : 'ls-error ls-error-old ';
    this.$locationWrapper = this.$el.find('.location-search, .ls-location-wrap');
  }

  LocationError.prototype.errorTemplate = function(query, message) {
    query = _.escape(query);
    message = _.escape(message);
    return "<ul role='list'><li data-bhw='SearchBarError' class='ls-error-dialog icon-circle-alert'>\n  <span data-bhc='location-not-found:" + query + "'>" + message + "</span>\n</li></ul>";
  };

  LocationError.prototype.displayError = function(message, query) {
    var $errorDialog, event;
    message || (message = this.translateError(I18N_ERROR_GENERIC));
    $errorDialog = $(this.errorTemplate(query, message));
    moveAutocomplete(this.$resultList, 'location', this.env);
    this.$locationWrapper.addClass(this.classes);
    this.$resultList.html($errorDialog).show();
    this.$locationWrapper.find('input').one('input.locationError', this.removeError);
    this.hasError = true;
    switch (this.env) {
      case 'desktop':
        event = 'mousedown';
        break;
      case 'mobile':
        event = 'touchend';
    }
    return $(window).one(event, this.removeError);
  };

  LocationError.prototype.removeError = function() {
    if (this.hasError) {
      this.$resultList.hide().find('.ls-error-dialog').remove();
      this.$locationWrapper.removeClass(this.classes);
      this.hasError = false;
    }
  };

  LocationError.prototype.displayBadLocationError = function(query) {
    var message, txtKey;
    if (this.expUX) {
      txtKey = I18N_ERROR_BAD_LOCATION_ENTRY;
    } else {
      txtKey = I18N_ERROR_BAD_LOCATION;
    }
    message = this.translateError(txtKey);
    return this.displayError(message, query);
  };

  LocationError.prototype.displayAvailabilityError = function(query) {
    var message;
    message = this.translateError(I18N_ERROR_AVAILABILITY);
    return this.displayError(message, query);
  };

  LocationError.prototype.translateError = function(key) {
    return getTranslations('error')[key];
  };

  return LocationError;

})();

//# sourceMappingURL=data:application/json;base64,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
